var I18N_ERROR_AVAILABILITY, I18N_ERROR_BAD_LOCATION, I18N_ERROR_BAD_LOCATION_ENTRY, I18N_ERROR_GENERIC, LocationError, getTranslations, moveAutocomplete, ref,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

I18N_ERROR_GENERIC = 'generic';

I18N_ERROR_BAD_LOCATION = 'bad_location';

I18N_ERROR_BAD_LOCATION_ENTRY = 'bad_location_entry';

I18N_ERROR_AVAILABILITY = 'availability';

ref = require('../helper/m_typeahead_helper'), getTranslations = ref.getTranslations, moveAutocomplete = ref.moveAutocomplete;

module.exports = LocationError = (function() {
  function LocationError(opts) {
    this.removeError = bind(this.removeError, this);
    this.displayError = bind(this.displayError, this);
    this.$el = opts.$el, this.env = opts.env, this.$resultList = opts.$resultList, this.expUX = opts.enableBetterUx;
    this.hasError = false;
    this.classes = this.expUX ? 'ls-error' : 'ls-error ls-error-old ';
    this.$locationWrapper = this.$el.find('.location-search, .ls-location-wrap');
  }

  LocationError.prototype.errorTemplate = function(query, message) {
    query = _.escape(query);
    message = _.escape(message);
    return "<ul role='list'><li data-bhw='SearchBarError' class='ls-error-dialog icon-circle-alert'>\n  <span data-bhc='location-not-found:" + query + "'>" + message + "</span>\n</li></ul>";
  };

  LocationError.prototype.displayError = function(message, query) {
    var $errorDialog, event;
    message || (message = this.translateError(I18N_ERROR_GENERIC));
    $errorDialog = $(this.errorTemplate(query, message));
    moveAutocomplete(this.$resultList, 'location', this.env);
    this.$locationWrapper.addClass(this.classes);
    this.$resultList.html($errorDialog).show();
    this.$locationWrapper.find('input').one('input.locationError', this.removeError);
    this.hasError = true;
    switch (this.env) {
      case 'desktop':
        event = 'mousedown';
        break;
      case 'mobile':
        event = 'touchend';
    }
    return $(window).one(event, this.removeError);
  };

  LocationError.prototype.removeError = function() {
    if (this.hasError) {
      this.$resultList.hide().find('.ls-error-dialog').remove();
      this.$locationWrapper.removeClass(this.classes);
      this.hasError = false;
    }
  };

  LocationError.prototype.displayBadLocationError = function(query) {
    var message, txtKey;
    if (this.expUX) {
      txtKey = I18N_ERROR_BAD_LOCATION_ENTRY;
    } else {
      txtKey = I18N_ERROR_BAD_LOCATION;
    }
    message = this.translateError(txtKey);
    return this.displayError(message, query);
  };

  LocationError.prototype.displayAvailabilityError = function(query) {
    var message;
    message = this.translateError(I18N_ERROR_AVAILABILITY);
    return this.displayError(message, query);
  };

  LocationError.prototype.translateError = function(key) {
    return getTranslations('error')[key];
  };

  return LocationError;

})();

//# sourceMappingURL=data:application/json;base64,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
